// extracted by mini-css-extract-plugin
module.exports = {"aliApplyFaildHome":"index-module_aliApplyFaildHome_p_7IG","empty":"index-module_empty_17Wlg"};